
import { request } from "../http";

export default {
    // 获取最近查看记录(案例，品牌，样版)
    getRecentlyViewedList(params) {
        return request('post', '/sd_smi/api/v1/Web_StoreRecord/getRecentlyViewedList', params, 'json');
    },

    // 获取购买记录
    getMyTransactionList(params) {
        return request('get', '/sd_smi/api/v1/Web_Appointment/getMyTransactionList', params, 'json');
    },

    // 获取最近查看记录
    // getRecentlyViewedList(params) {
    //     return request('post', '/sd_smi/api/v1/Web_StoreRecord/getRecentlyViewedList', params, 'json');
    // },

    // 获取进店记录列表
    getClientRecordList(params) {
        return request('post', '/sd_smi/api/v1/Web_StoreRecord/getClientRecordList', params, 'json');
    },


    // 预约部分
    // 获取预约门店/sd_smi/api/v1/Web_Appointment/getAppointmentStoreList
    getAppointmentStoreList(params) {
        // 提取url的storeType参数，注意在hash前面
        const searchParams = new URLSearchParams(window.location.search);
        const storeType = searchParams.get('storeType');
        if (storeType) {
          params.storeType = storeType.replace(/\/$/, '');
        }
        return request('post', `/sd_smi/api/v1/Sys_Public/getAppointmentStoreList2`, params, 'json', {useParams: true});
    },

    // 获取预约详情
    getAppointmentDetail(params) {
        return request('post', `/sd_smi/api/v1/Web_Appointment/getAppointmentDetail?appointmentId=${params.appointmentId}`, params, 'json');
    },

    // 获取预约表单项目
    getAppointmentItem(params) {
        return request('post', '/sd_smi/api/v1/Web_Appointment/getAppointmentItem', params, 'json');
    },

    // 添加预约
    addAppointment(params) {
        return request('post', '/sd_smi/api/v1/Web_Appointment/addAppointment', params, 'json');
    },

    // 获取预约详情
    // getAppointmentDetail(params) {
    //     return request('post', '/sd_smi/api/v1/Web_Appointment/getAppointmentDetail', params, 'json');
    // },

    // 最新预约数统计接口
    getAppointmentIsNew(params={}) {
        return request('post', `/sd_smi/api/v1/Web_Appointment/getAppointmentIsNew?isArrived=${params.isArrived}`, params, 'json');
    },

    // 获取我的预约记录
    getMyAppointmentList(params) {
        return request('post', `/sd_smi/api/v1/Web_Appointment/getMyAppointmentList?isArrived=${params.isArrived}`, params, 'json');
    },

    // 获取进店记录评价项
    getClientRecordStarItem(params) {
        return request('get', '/sd_smi/api/v1/Web_Appointment/getClientRecordStarItem', params, 'json');
    },

    // 评价进店记录
    addClientRecordStar(params) {
        return request('post', '/sd_smi/api/v1/Web_Appointment/submitClientRecordStar', params, 'json');
    },

    // 获取购买详情
    getMyTransactionDetail(params) {
        return request('get', '/sd_smi/api/v1/Web_Appointment/getMyTransactionDetail', params, 'json');
    },

    // 获取进店记录详情
    getClientRecordDetail(params) {
        return request('post', '/sd_smi/api/v1/Web_StoreRecord/getClientRecordDetail', params, 'json', {useParams: true});
    },

    // 记录预约为已读取
    setReaded(params) {
        return request('post', '/sd_smi/api/v1/Web_StoreRecord/setReaded', params, 'json', {useParams: true});
    },

  // 获取预约表单项目
  addAppointmentByNoLogin(params) {
      return request('post', '/sd_smi/api/v1/Web_Appointment/addAppointmentByNoLogin', params, 'json');
    },
}



// WEBPACK FOOTER //
// ./src/request/apis/store.js